export const headerNavLinks = [
  { name: 'Home', url: '/' },
  { name: 'About', url: '/about' },
  { name: 'Contact', url: '/contact' },
  { name: 'Blog', url: '/blog' },
  { name: 'Careers', url: '/careers' },
];

export const footerNavLinks = [
  { name: 'About', url: '/about' },
  { name: 'Contact', url: '/contact' },
  { name: 'Blog', url: '/blog' },
  { name: 'Careers', url: '/careers' },
  { name: 'Support', url: '/support' },
  { name: 'Privacy Policy', url: '/privacy-policy' },
];
